<template>
  <div class="h-scroll h100-80">
    <div class="h-topo-tree">
      <ejs-treeview ref='NeTreeForTask' :fields='fieldsOfNeTreeForTask' :nodeSelected='nodeSelectedOfNeTreeForTask'></ejs-treeview>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeTreeForTask',
  data() {
    return {
      fieldsOfNeTreeForTask: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text',
      }
    };
  },
  methods: {
    // 网元树内容获取
    getNeTree() {
      this.$axios.get('/lte/pm/buildNeUnderTaskTree.html?systemId=1').then((response) => {
        this.fieldsOfNeTreeForTask = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },

    // 网元树点击事件
    nodeSelectedOfNeTreeForTask(args) {
      let NeId = '';
      let NeTypeId = '';
      const attribute = this.$refs.NeTreeForTask.getTreeData(args.nodeData.id)[0].attributes;
      if (attribute) {
        NeTypeId = attribute.neTypeId ? attribute.neTypeId : '';
        NeId = attribute.neId ? attribute.neId : '';
      }
      const params = {
        neId: NeId,
        neTypeId: NeTypeId,
        treeType: '2'
      };
      // 网元树点击节点信息事件发布
      this.$emit('transferNe', params);
    }
  }
};
</script>

<style>

</style>
